import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large' | 'small';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  const sizeClasses = {
    large: 'w-full',
    normal: 'w-full',
    small: 'w-full',
  };

  const imgHeight = {
    large: 'h-72',
    normal: 'h-56',
    small: 'h-44',
  };

  return (
    <Link
      to={`/article/${movie.id}`}
      className={`block group cursor-pointer ${sizeClasses[size]}`}
    >
      <div className={`relative overflow-hidden rounded-lg ${imgHeight[size]} mb-3`}>
        <img
          src={movie.poster}
          alt={movie.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-foreground-50 text-xs font-medium line-clamp-2">{movie.description}</span>
        </div>
        {/* Rating badge */}
        <div className="absolute top-2 right-2 bg-background-900/80 backdrop-blur-sm px-2 py-0.5 rounded-md flex items-center gap-1">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-primary-500 text-xs"></i>
          </div>
          <span className="text-primary-400 text-xs font-bold">{movie.rating}</span>
        </div>
        {/* Hot/New badge */}
        {movie.isHot && (
          <div className="absolute top-2 left-2 bg-accent-500 text-foreground-50 text-xs px-2 py-0.5 rounded-md font-medium">
            热播
          </div>
        )}
        {movie.isNew && !movie.isHot && (
          <div className="absolute top-2 left-2 bg-primary-500 text-background-950 text-xs px-2 py-0.5 rounded-md font-medium">
            新上
          </div>
        )}
        {movie.isNew && movie.isHot && (
          <div className="absolute top-2 left-2 bg-primary-500 text-background-950 text-xs px-2 py-0.5 rounded-md font-medium">
            新上
          </div>
        )}
      </div>
      <h3 className="text-foreground-100 text-sm font-medium group-hover:text-primary-400 transition-colors line-clamp-1">
        {movie.title}
      </h3>
      <div className="flex items-center gap-2 mt-1 text-foreground-500 text-xs">
        <span>{movie.year}</span>
        <span className="text-background-600">|</span>
        <span>{movie.category}</span>
        <span className="text-background-600">|</span>
        <span>{movie.duration}</span>
      </div>
    </Link>
  );
}